// Blurs the input on a drag to get the soft keyboard off a fixed overlay, which the browser's
// native dismiss-on-scroll never reaches.
// touchmove, not scroll: only a user gesture should steal focus, and it fires only on touch devices,
// so no viewport or pointer media query is needed.
// Returns a dispose function.
export const dismissKeyboardOnDrag = (root: HTMLElement, input: HTMLInputElement): (() => void) => {
  const abortController = new AbortController();

  const onTouchMove = (e: Event) => {
    // The listener outlives any single focus.
    if (document.activeElement !== input) return;
    // A drag that starts on the input moves the caret.
    if (e.target === input) return;

    input.blur();
  };

  root.addEventListener('touchmove', onTouchMove, { passive: true, signal: abortController.signal });

  return () => abortController.abort();
};
